module.exports = __webpack_public_path__ + "img/49ae8.5e7482ec.png";